<app-selector
  label="Spot On Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="spotOnGameCoreService.spotOnGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="spotOnGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
